import { useNotificationBadgeQuery } from 'gqlhooks';

/**
 * ТЗ 0121: число непрочитанных для вкладки «Уведомления» на телефоне —
 * то же, что у колокольчика шапки, но БЕЗ своего опроса: читает кеш Apollo,
 * который наполняет и освежает `useNotificationBadge` колокольчика. Второй
 * подписчик с `cache-and-network` удвоил бы опрос однопоточного бэкенда.
 */
export const useNotificationUnreadCount = (): number => {
  const { data } = useNotificationBadgeQuery({ fetchPolicy: 'cache-only' });
  return data?.staffNotificationsSummary?.unreadCount ?? 0;
};
